<template>
    <div class="salvage-outline">
        <h2 class="heading d-flex justify-content-between">
            <span>
                {{caption}}
            </span>
        </h2>
        <div class="salvage-box bg-blur" v-for="n in novels" :key="n.id">
            <a href="#" @click.prevent="showNovel(n)" class="d-flex justify-content-between text-reset">
                <div class="pt-3">
                    <h3 class="title mincho">
                        <span v-html="$filters.ruby(n.title)"></span>
                        <span v-if="!n.is_long" class="badge badge-secondary">短編</span>
                    </h3>
                    <h5 class="author">{{n.author.name}}</h5>
                    <p class="description">
                        {{ $filters.truncate(n.description, 100)}}
                    </p>
                </div>
                <img v-lazy="n.cover_url.replace(/\.webp$/, '_thumb.webp') + '?' + n.cover_hash" class="d-block cover" v-if="n.cover_url" />
                <div v-else class="position-relative">
                    <img v-lazy="cover()" class="d-block cover" />
                    <div class="slider-text">
                        <div class="cover-text vertical">
                            <h3 class="novel-title mincho" v-html="$filters.ruby(n.title)"></h3>
                            <p v-if="n.subtitle" v-html="$filters.ruby(n.subtitle)"></p>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>

<style scoped lang="scss">
.salvage-outline {
    .salvage-box {
        margin-top: 1rem;
        width: 100%;
        height: 167px;
        overflow: hidden;
        a {
            &:hover {
                opacity: .8;
                text-decoration: none;
            }
        }
        .cover {
            object-fit: cover;
            height: 167px;
            min-width: 118px;
            width: 118px;
        }
        .title {
            font-size: 1rem;
            font-weight: bold;
            margin: 0;
            padding: 0 1rem;
        }
        .subtitle {
            font-size: .8rem;
            padding: .5rem 1rem 0;
        }
        .author {
            font-size: .8rem;
            padding: .5rem 1rem 0;
        }
        .description {
            font-size: .7rem;
            padding: .6rem 1rem;
        }
        .slider-text {
            position: absolute;
            top: 0;
            padding: 1rem;
            height: 167px;
            min-width: 118px;
            overflow: hidden;
            text-align: center;
            color: snow;
            .cover-text {
                display: inline-block;
                text-align: left;
                h3 {
                    font-size: .7rem;
                }
                p {
                    font-size: .6rem;
                }
            }
        }
    }
    .heading {
        font-size: 1rem;
        font-weight: bold;
        margin: 0;
        padding: 1rem 1rem .5rem;
    }
    .link {
        font-size: .8rem;
        font-weight: lighter;
    }
}
</style>

<script>
export default {
    props: {
        novels: {
            required: true,
            default: [],
        },
        caption: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            salvages: [],
        }
    },
    methods: {
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
        showNovel(n) {
            this.$emit("showNovel", n);
        },
    },
    mounted() {}
}
</script>